/**
 * @desc 打点统计
 */
import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export enum EPageType {
    ANNUAL2018 = '1',
    INFLUENCE_INVITE = '2',
    INFLUENCE_BOOST = '3',
    INFLUENCE_BOOSTED = '4',
    INFLUENCE_INVITED = '5',
    INFLUENCE_SHARE = '6',
    ANNUAL2019 = '7',
    ANNUAL2020 = '8',
    ANNUAL2021 = '9',
}

// 入参的两个值每个页面不同，可能无法重用，后续看如何提升公共类型
export interface IInput {
    page_type: EPageType;
    action_type: string; // EActionType 下放到业务中去了
}

export const viewLog = (data: IInput): Promise<IResponse<{}>> => {
    return fetchData(Api.VIEW_LOG, data).then((res: IResponse<{}>) => {
        return res;
    });
};

export const viewLogSync = fetchDataSync(viewLog);
